import script from "./ProspectoListView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProspectoListView.vue?vue&type=script&setup=true&lang=js"

import "./ProspectoListView.vue?vue&type=style&index=0&id=0c9c5aca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c9c5aca"]])

export default __exports__